import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  NAVIGATE: COMMON_EVENT_NAMES.NAVIGATED,
  OPEN: "Tutorial Selected",
  LOAD: "Tutorial Viewed",
  NEXT: "Tutorial CTA Clicked",
  CLOSE: "Tutorial Closed"
};
